export const getAdjustedDropdownPosition = (
  value: number | string,
  offset?: number
) => (typeof value === 'number' ? value + (offset ?? 0) : value);
